"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Grid_1 = require("@material-ui/core/Grid");
const Typography_1 = require("@material-ui/core/Typography");
const styles_1 = require("@material-ui/core/styles");
const assets_1 = require("../config/assets");
const package_1 = require("../package");
const ArcadeMessagePopup = ({ classes, open, onClose, title, text, closeText, disableBackdropClick, hideXButton, onClickXButton }) => ((0, jsx_runtime_1.jsx)(package_1.InformationDialog, Object.assign({ open: open, onClose: onClickXButton ? onClickXButton : onClose, maxWidth: 'sm', hideButton: true, hideXButton: hideXButton !== undefined ? hideXButton : true, disableBackdropClick: disableBackdropClick }, { children: (0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ container: true, spacing: 2, className: classes.content }, { children: [(0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: "subtitle1", align: 'center', className: classes.title }, { children: title })) })), (0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, xs: 12, style: {
                    display: 'flex',
                    justifyContent: 'center'
                } }, { children: (0, jsx_runtime_1.jsx)("img", { alt: 'Warning icon', "aria-hidden": "true", src: assets_1.assets.internalAssets.iconAlertWarning }) })), (0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: "body1", className: classes.text, align: 'center' }, { children: text })) })), (0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, xs: 12, className: classes.btnContainer }, { children: (0, jsx_runtime_1.jsx)(package_1.ArcadePopupButton, { title: closeText, onSubmit: onClose }) }))] })) })));
const styles = (theme) => (0, styles_1.createStyles)({
    content: {
        padding: theme.spacing(2)
    },
    title: {
        color: theme.palette.common.black,
        marginBottom: theme.spacing(2)
    },
    btnContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    text: {
        color: theme.palette.common.black
    }
});
exports.default = (0, styles_1.withStyles)(styles)(ArcadeMessagePopup);
//# sourceMappingURL=ArcadeMessagePopup.js.map